import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatExhibitionDimensionsDisplay } from '../pages/website/exhibitionLogisticsRfqFormState';

function str(value) {
  if (value === null || value === undefined || String(value).trim() === '') return '—';
  return String(value);
}

/**
 * @param {Record<string, unknown>} params
 */
export function downloadExhibitionLogisticsRfqPdf({
  rfq,
  orgLoc,
  venueLoc,
  selectedServices,
  formatSubmittedAt,
  formatDateSlash,
  logisticsModeLabel,
  formatDeclaredValue,
}) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginX = 40;
  let cursorY = 48;

  const tableOpts = {
    margin: { left: marginX, right: marginX },
    theme: 'grid',
    styles: { fontSize: 9, cellPadding: 6, textColor: [15, 28, 51] },
    headStyles: { fillColor: [245, 247, 250], textColor: [102, 112, 133], fontStyle: 'bold' },
    columnStyles: { 0: { cellWidth: 150, fontStyle: 'bold' } },
  };

  const rfqRef = rfq.rfqId || rfq.rfqReference || '—';
  const statusLabel = String(rfq.status || 'pending')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('Exhibition & Expo Logistics', marginX, cursorY);
  cursorY += 22;

  autoTable(doc, {
    startY: cursorY,
    ...tableOpts,
    body: [
      ['RFQ ID', str(rfqRef)],
      ['Status', statusLabel],
      ['Submitted', str(formatSubmittedAt(rfq.createdAt || rfq.submittedDate))],
      ['Buyer', str(rfq.buyerName || rfq.contactPerson)],
      ['Company', str(rfq.companyName)],
      ['Contact', str(rfq.contactNumber)],
      ['Email', str(rfq.companyEmail)],
    ],
  });
  cursorY = (doc.lastAutoTable?.finalY || cursorY) + 18;

  autoTable(doc, {
    startY: cursorY,
    ...tableOpts,
    body: [
      ['Exhibition', str(rfq.exhibitionName)],
      ['Setup date', formatDateSlash(rfq.setupDate)],
      ['Start', formatDateSlash(rfq.exhibitionStartDate)],
      ['End', formatDateSlash(rfq.exhibitionEndDate)],
    ],
  });
  cursorY = (doc.lastAutoTable?.finalY || cursorY) + 18;

  autoTable(doc, {
    startY: cursorY,
    ...tableOpts,
    head: [['Organization location', '']],
    body: [
      ['Country', str(orgLoc.country)],
      ['State', str(orgLoc.state)],
      ['City', str(orgLoc.city)],
      ['Address', str(rfq.orgAddress)],
    ],
  });
  cursorY = (doc.lastAutoTable?.finalY || cursorY) + 18;

  autoTable(doc, {
    startY: cursorY,
    ...tableOpts,
    head: [['Venue location', '']],
    body: [
      ['Country', str(venueLoc.country)],
      ['State', str(venueLoc.state)],
      ['City', str(venueLoc.city)],
      ['Booth', str(rfq.boothNumber)],
      ['Address', str(rfq.venueAddress)],
    ],
  });
  cursorY = (doc.lastAutoTable?.finalY || cursorY) + 18;

  autoTable(doc, {
    startY: cursorY,
    ...tableOpts,
    body: [
      ['Materials', str(rfq.materialsDescription || rfq.goodsDescription)],
      ['Weight', `${str(rfq.totalWeightKg)} ${rfq.totalWeightUnit || 'KG'}`.trim()],
      ['Packages', str(rfq.numberOfPackages)],
      ['Dimensions', str(formatExhibitionDimensionsDisplay(rfq))],
      ['Declared value', str(formatDeclaredValue(rfq))],
      ['Logistics mode', logisticsModeLabel(rfq.logisticsMode)],
    ],
  });
  cursorY = (doc.lastAutoTable?.finalY || cursorY) + 12;

  const lines = doc.splitTextToSize(
    `Additional services: ${selectedServices.length ? selectedServices.join(', ') : 'None'}`,
    pageWidth - marginX * 2,
  );
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text(lines, marginX, cursorY);

  const fileName = `${String(rfqRef).replace(/[^\w-]+/g, '_') || 'exhibition-logistics-rfq'}.pdf`;
  doc.save(fileName);
}
